<template>
	<v-navigation-drawer
		v-model="$store.menuStore.state.menuSidebarStatus"
		fixed
		:mini-variant="$store.menuStore.state.sidebarMini"
		:width="$store.menuStore.state.sidebarMini ? '60':'240'"
		class="modern-sidebar"
	>
		<div class="sidebar-content">
			<div class="sidebar-topbar">
				<img :src="require('../../assets/Svg/logoH.svg')" class="sidebar-logo-top" v-show="!$store.menuStore.state.sidebarMini"/>
				<v-btn icon small @click="toggleMenu" class="toggle-btn-inline">
					<v-icon size="20" color="#5E85EF">mdi-menu</v-icon>
				</v-btn>
			</div>
			<div class="sidebar-header">
				<div v-if="$store.userStore.state.userInfo">
					<!-- Fila 1: avatar usuario + nombre y cargo -->
					<div class="user-row" v-if="!$store.menuStore.state.sidebarMini">
						<img v-if="$store.userStore.state.userInfo.info.avatar" :src="$store.userStore.state.userInfo.info.avatar" class="user-avatar-sm"/>
						<v-icon v-else class="user-avatar-icon" color="#5E85EF">mdi-account-circle</v-icon>
						<div class="user-info">
							<p class="mb-0 user-name">{{$store.userStore.state.userInfo.name}}</p>
							<p class="mb-0 user-job" v-if="$store.projectsStore.state.selectedProject && $store.projectsStore.state.selectedProject.job_type">{{$store.projectsStore.state.selectedProject.job_type.name}}</p>
						</div>
					</div>
					<!-- Fila 2: foto proyecto + nombre + selector -->
					<ProjectSelector />
					<!-- Mini mode: solo avatar usuario -->
					<div v-if="$store.menuStore.state.sidebarMini" class="d-flex justify-center">
						<img v-if="$store.userStore.state.userInfo.info.avatar" :src="$store.userStore.state.userInfo.info.avatar" class="user-avatar-mini"/>
						<v-icon v-else color="#5E85EF">mdi-account-circle</v-icon>
					</div>
				</div>
				<div v-else>
					<v-skeleton-loader type="list-item-avatar"></v-skeleton-loader>
				</div>
			</div>
			<div class="menu-container">
				<Menu />
			</div>
			<div class="logout-container">
				<PanelSelector v-show="!$store.menuStore.state.sidebarMini" class="mb-2" v-if="showPanelSelector" />
				<v-btn text small block color="#999" class="logout-btn" @click="logout()">
					<v-icon small class="mr-1">mdi-logout</v-icon>
					<span v-show="!$store.menuStore.state.sidebarMini">Salir</span>
				</v-btn>
				<router-link
					class="text-none text-center text-decoration-none"
					style="width: 100%;color: #999;"
					:to="{ name: 'PrivacyPolicy'}"
					target="_blank">
					<p class="caption text-none mb-0 font-weight-bold">Politicas de Privacidad</p>
				</router-link>
				<p class="version-label my-1 pb-0" v-show="!$store.menuStore.state.sidebarMini">LaOT © {{ new Date().getFullYear() }} - Versión 1.5.0</p>
			</div>
		</div>
	</v-navigation-drawer>
</template>

<script>
import Menu from './Menu/Index'
import PanelSelector from '@/components/Globals/Headers/PanelSelector'
import ProjectSelector from '@/components/Layout/Helpers/ProjectSelector'
export default {
	name: 'Sidebar',
	components: { Menu, PanelSelector, ProjectSelector },
	computed: {
		showPanelSelector() {
			return process.env.VUE_APP_SHOW_PANEL_SELECTOR === 'true'
		}
	},
	data: () => ({
	}),
	methods: {
		toggleMenu(){
			if(this.$vuetify.breakpoint.mobile){
				this.$store.menuStore.commit('setMenuSidebarStatus', !this.$store.menuStore.state.menuSidebarStatus)
				return null
			}
			this.$store.menuStore.commit('toggleSidebarMini')
		},
		logout(){
			this.$store.userStore.commit('logoutUser')
			this.$router.push({name: 'Login'})
		},
		async changeProject(index){
			const projectID = this.$store.projectsStore.state.projectsList[index].id
			const companyID = this.$store.projectsStore.state.projectsList[index].company_id
			const project = await this.$store.projectsStore.dispatch('getSelectedProject', projectID)
			if(!project){
				const data = {
					message: 'No tienes acceso a este proyecto o ha ocurrido un error al cargarlo. Si crees que esto es un error, contacta con el administrador del proyecto.',
					title: 'Sin acceso al proyecto',
					created: new Date(),
					type: 'warning',
					icon: 'mdi-alert-circle',
					color: '#fb8c00'
				}
				this.$store.globalStore.dispatch('addMessage', data)
				return null
			}
			if(this.$store.userStore.state.userCompanies.length > 0){
				const found = this.$store.userStore.state.userCompanies.find((company) => {
					return company.company_id = companyID
				})
				if(found){
					this.$store.userStore.commit('setCompanyPermissions', found.capabilities)
					this.$store.userStore.commit('setSelectedCompany', found)
				}
			}

			this.getConsultasList(projectID)
			this.getRdiList(projectID)
			this.getAdditionalList(projectID)
			this.getDashboardInfo()
			this.getProjectUserList(projectID)
		},
    async getConsultasList(project_id){
      if(project_id){
        this.$store.consultasStore.dispatch('getMyTasks', {project_id})
      }
    },
    async getRdiList(project_id){
			if(project_id){
				this.$store.rdiStore.dispatch('getRDI', {project_id})
			}
			if(this.$store.rdiStore.state.selectedType == 4){
				this.$store.rdiStore.dispatch('getRdiGraphsData', {project_id})
			}
			else{
				this.$store.rdiStore.dispatch('getRDI', {project_id})
			}
    },
	async getEntregaList(project_id){
			if(project_id){
				this.$store.entregaStore.dispatch('getEntrega', {project_id})
			}
			if(this.$store.entregaStore.state.selectedType == 4){
				this.$store.entregaStore.dispatch('getEntregaGraphsData', {project_id})
			}
			else{
				this.$store.entregaStore.dispatch('getEntrega', {project_id})
			}
    },
		async getAdditionalList(project_id){
				if(!project_id){
					return null
				}
				if(this.$store.adicionalesStore.state.selectedType == 4){
					this.$store.adicionalesStore.dispatch('getAdditionalsLikely', {project_id})
				}
				if(this.$store.adicionalesStore.state.selectedType == 3){
					this.$store.adicionalesStore.dispatch('getAdditionalInformativeTable', {project_id})
				}
				else{
					this.$store.adicionalesStore.dispatch('getAdditionals', {project_id})
				}
		},
		getDashboardInfo(){
			this.$store.projectsStore.dispatch('getDashboardInfo')
			this.$store.fileManagerStore.dispatch('getProjectStorageSize', {
				project_id: this.$store.projectsStore.state.selectedProject.id
			})
		},
		getProjectUserList(projectID){
			const data = {
				project_id: projectID,
				start: 0,
				limit: 20
			}
			this.$store.usersStore.dispatch('getUsersList', data)
		}
	}
};
</script>
<style>
	/* Modern Sidebar Styles */
	.modern-sidebar {
		background: linear-gradient(180deg, #ffffff 0%, #f8f9fc 100%) !important;
		border-right: 1px solid #e8eaf0 !important;
	}
	
	.sidebar-content {
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
	}
	
	/* Top bar logo + toggle */
	.sidebar-topbar {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 10px 8px 0 12px;
		flex: 0 0 auto;
	}

	.sidebar-logo-top {
		max-width: 78px;
		width: 100%;
	}

	.toggle-btn-inline {
		flex-shrink: 0;
	}
	
	.sidebar-header {
		flex: 0 0 auto;
		padding: 8px 12px 8px;
		border-bottom: 1px solid #eef0f5;
		margin-bottom: 4px;
	}

	/* User row */
	.user-row {
		display: flex;
		align-items: center;
		gap: 8px;
		margin-bottom: 6px;
	}

	.user-avatar-sm {
		width: 34px;
		height: 34px;
		border-radius: 50%;
		object-fit: cover;
		border: 2px solid #e8eaf0;
		flex-shrink: 0;
	}

	.user-avatar-icon {
		font-size: 34px !important;
		flex-shrink: 0;
	}

	.user-avatar-mini {
		width: 32px;
		height: 32px;
		border-radius: 50%;
		object-fit: cover;
		border: 2px solid #e8eaf0;
	}

	.user-info {
		text-align: left;
		min-width: 0;
	}

	.user-name {
		font-size: 12px;
		font-weight: 600;
		color: #2c3e50;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.user-job {
		font-size: 11px;
		color: #5E85EF;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	/* Avatar Section */
	.sidebar-avatars-container {
		width: 70px;
		height: 70px;
		position: relative;
		margin: auto;
	}

	.user-avatar {
		width: 60px;
		height: 60px;
		border-radius: 50%;
		object-fit: cover;
		border: 3px solid #ffffff;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
		transition: all 0.3s ease;
	}
	
	.user-avatar:hover {
		transform: scale(1.05);
		box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
	}
	
	.user-avatar.mini {
		width: 36px;
		height: 36px;
		border: 2px solid #ffffff;
	}
	
	.user-avatar.icon {
		background: linear-gradient(135deg, #667eea 0%, #5E85EF 100%);
		color: white !important;
	}
	
	.project-avatar-sidebar {
		width: 28px;
		height: 28px;
		border-radius: 50%;
		position: absolute;
		bottom: 0;
		right: -2px;
		border: 2px solid #ffffff;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
		object-fit: cover;
	}
	
	/* User Info */
	.user-info-section {
		padding: 0 8px;
	}
	
	.user-name {
		font-size: 14px;
		font-weight: 600;
		color: #2c3e50;
		margin-bottom: 4px;
	}
	
	.job-type {
		font-size: 12px;
		color: #5E85EF;
		font-weight: 500;
	}
	
	.project-name {
		font-size: 12px;
		color: #2D4B95;
		font-weight: 600;
	}
	
	.swap-project-btn {
		width: 24px !important;
		height: 24px !important;
		background: linear-gradient(135deg, #667eea 0%, #5E85EF 100%) !important;
		transition: all 0.3s ease;
	}
	
	.swap-project-btn:hover {
		transform: rotate(180deg);
		box-shadow: 0 4px 12px rgba(94, 133, 239, 0.3);
	}
	
	/* Menu Container */
	.menu-container {
		flex: 1;
		overflow-y: auto;
		overflow-x: hidden;
		padding: 4px 8px;
	}
	
	.menu-container::-webkit-scrollbar {
		width: 4px;
	}
	
	.menu-container::-webkit-scrollbar-track {
		background: transparent;
	}
	
	.menu-container::-webkit-scrollbar-thumb {
		background: #d0d5dd;
		border-radius: 4px;
	}
	
	.menu-container::-webkit-scrollbar-thumb:hover {
		background: #98a2b3;
	}
	
	/* Logout Button */
	.logout-container {
		margin-top: auto;
		padding: 4px 8px 8px;
		border-top: 1px solid #eef0f5;
	}

	.logout-btn {
		text-transform: none !important;
		letter-spacing: 0 !important;
		font-size: 12px !important;
		color: #999 !important;
		transition: color 0.2s ease;
	}

	.logout-btn:hover {
		color: #e74c3c !important;
	}

	.version-label {
		text-align: center;
		font-size: 10px;
		color: #999;
		margin: 0;
		padding-bottom: 4px;
		letter-spacing: 0.03em;
	}

	.v-skeleton-loader__bone {
		margin-right: auto;
		margin-left: auto;
	}
</style>